module.exports = __webpack_public_path__ + "img/16.ff9d1a0e.jpg";